import { createNextHook, createStateHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useUserChangePasswordState = createStateHook(
  AppStoreProvider,
  state => state.pages.userChangePassword
)
export const useNextUserChangePasswordState = () =>
  createNextHook(AppStoreProvider, state => state.pages.userChangePassword)
